
/**
 * 工作流-API节点
 * zxw
 * 创建时间 2026-04-09
 */

import {
    winHeight,
} from '../../incs/FunHelper';
import { useState, useEffect } from 'react';
import {
    ConfigProvider,
    Modal,
    Avatar,
    Space,
    Divider,
    Input,
    Select,
    Button,
    Typography,
    Row,
    Col,
    InputNumber,
    Tag,
    Cascader,
} from 'antd';
import {
    CheckOutlined,
    EditOutlined,
    PlusOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import CNF from '../../incs/Config';

const { Text } = Typography;

const APINodeEntity = (props) => {
    const [open, setOpen] = useState(false);
    const [isEditTitle, setIsEditTitle] = useState(false);  // 标题是否编辑
    const [currentTitle, setCurrentTitle] = useState('');   // 当前标题

    const [type, setType] = useState('GET');        // 请求方法
    const [url, setUrl] = useState('');             // 请求地址
    const [params, setParams] = useState([]);       // 请求参数
    const [response, setResponse] = useState({});   // 响应数据


    const cancel = () => {
        setOpen(false);
        setIsEditTitle(false);
    }

    useEffect(() => {
        setOpen(props.open);

        setCurrentTitle(props.node.data?.title);

        // 初始化
        setType((props.node?.data?.input?.type) ? props.node?.data?.input?.type : 'GET');
        setUrl(props.node?.data?.input?.url);
        setParams((props.node?.data?.input?.params) ? props.node?.data?.input?.params : []);
        setResponse(props.node?.data?.input?.response);
    }, [props]);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}>
            <Modal
                title={
                    <Space>
                        <Avatar size='small' shape='square' icon={props.node.data?.icon} style={{ background: props.node.data?.theme, }} />
                        {
                            isEditTitle ? <Input
                                value={currentTitle}
                                onChange={(e) => {
                                    setCurrentTitle(e.target.value);
                                }}
                            /> : props.node.data?.title
                        }
                        {
                            isEditTitle ?
                                <Button color='primary' variant='link' icon={<CheckOutlined />} onClick={() => {
                                    props.node.setData({
                                        ...props.node.data,
                                        title: currentTitle,
                                    });
                                    setIsEditTitle(false);
                                }} />
                                :
                                <Button color='primary' variant='link' icon={<EditOutlined />} onClick={() => {
                                    setIsEditTitle(true);
                                }} />
                        }
                    </Space>
                }
                width={480}
                height={winHeight - CNF.menuHeight - CNF.basePadding * 2}
                style={{
                    top: CNF.menuHeight + CNF.basePadding,
                    right: 18,
                    position: 'absolute',
                }}
                mask={{
                    enabled: false,
                    closable: true,
                }}
                open={open}
                onCancel={cancel}
                footer={null}
            >
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>动作</p>
                <Select
                    style={{ width: '100%' }}
                    options={CNF.apiTypes.map(item => {
                        return {
                            label: item,
                            value: item,
                        }
                    })}
                    value={type}
                    onChange={(value) => {
                        setType(value);
                        props.node.setData({
                            ...props.node.data,
                            input: {
                                type: value,
                            },
                        });
                    }}
                />
                <p>地址</p>
                <Input
                    placeholder='请输入地址'
                    style={{
                        width: '100%',
                    }}
                    value={url}
                    onChange={(e) => {
                        setUrl(e.target.value);
                        props.node.setData({
                            ...props.node.data,
                            input: {
                                url: e.target.value,
                            },
                        });
                    }}
                />
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>param参数设置</p>
                <Row>
                    <Col span={6}>变量名</Col>
                    <Col span={4}>引用方式</Col>
                    <Col span={14}>值</Col>
                </Row>
                {
                    params && params.map((item, index) => {
                        // 通用更新函数：更新指定索引的字段
                        const updateParam = (field, value) => {
                            const newParams = params.map((p, i) =>
                                i === index ? { ...p, [field]: value } : p
                            );
                            setParams(newParams);
                            props.node.setData({
                                ...props.node.data,
                                input: {
                                    params: newParams,
                                },
                            });
                        };

                        // 获取Cascader值
                        const getCascaderValue = (value) => {
                            if (value) {
                                return [props.graph.getNodes().find(node => node.getZIndex().toString() === value.split('/')[0])?.data.title, value];
                            } else {
                                return [];
                            }
                        };

                        // 根据变量类型返回对应组件
                        const getVariableComponent = (type) => {
                            if (type === 'string') {
                                return <Input
                                    placeholder='请输入变量值'
                                    value={item.value}
                                    onChange={(e) => updateParam('value', e.target.value)}
                                />
                            } else if (type === 'number') {
                                return <InputNumber
                                    placeholder='请输入变量值'
                                    style={{ width: '100%' }}
                                    value={item.value}
                                    onChange={(value) => updateParam('value', value)}
                                />
                            }
                        };

                        return <Row key={index} style={{ marginTop: 5, }}>
                            <Col span={6} style={{ paddingRight: 8, }}>
                                <Input
                                    placeholder='请输入变量名'
                                    size='small'
                                    value={item.name}
                                    onChange={(e) => updateParam('name', e.target.value)}
                                />
                            </Col>
                            <Col span={4} style={{ paddingRight: 8, }}>
                                <Select
                                    style={{ width: '100%' }}
                                    size='small'
                                    options={CNF.referenceMethods.map(item => {
                                        return {
                                            label: item,
                                            value: item,
                                        }
                                    })}
                                    value={item.referenceMethod}
                                    onChange={(value) => updateParam('referenceMethod', value)}
                                />
                            </Col>
                            <Col span={13}>
                                {
                                    item.referenceMethod === '输入' ?
                                        <Space.Compact size='small'>
                                            <Select
                                                popupMatchSelectWidth={false}
                                                options={CNF.variableTypes.map(item => {
                                                    return {
                                                        label: item,
                                                        value: item,
                                                    }
                                                })}
                                                value={item.type}
                                                onChange={(value) => updateParam('type', value)}
                                            />
                                            {
                                                getVariableComponent(item.type)
                                            }

                                        </Space.Compact>
                                        :
                                        <Cascader
                                            placeholder='请选择变量'
                                            size='small'
                                            style={{ width: '100%' }}
                                            options={props.graph && props.graph.getNodes()
                                                .filter(node => !(node.data?.key === 'End' || node.getZIndex() >= props.node.getZIndex()))
                                                .map((node) => {
                                                    return {
                                                        label: node.data.title,
                                                        value: node.data.title,
                                                        children: Object.keys(node.data?.key === 'Start' ? node.data?.input.sys : node.data?.output).map((item) => {
                                                            const path = node.getZIndex().toString() + (node.data?.key === 'Start' ? '/input/sys/' : '/output/') + item;
                                                            return {
                                                                label: <Space><Text>{item}</Text><Tag>string</Tag></Space>,
                                                                value: path,
                                                            }
                                                        }),
                                                    }
                                                })}
                                            value={getCascaderValue(item.value)}
                                            onChange={(value) => {
                                                updateParam('value', value[1])
                                            }}
                                        />
                                }
                            </Col>
                            <Col span={1}>
                                <Button
                                    size='small'
                                    color='primary'
                                    variant='link'
                                    icon={<DeleteOutlined />}
                                    onClick={() => {
                                        setParams(prev => prev.filter((_, i) => i !== index));
                                    }}
                                />
                            </Col>
                        </Row>
                    })
                }

                <Button size='small' color='primary' variant='link' icon={<PlusOutlined />} style={{ padding: 0 }} onClick={() => {
                    setParams([...params, {
                        name: '',
                        value: '',
                        type: CNF.variableTypes[0],
                        referenceMethod: CNF.referenceMethods[0],
                    }]);
                }}>添加变量</Button>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>响应设置</p>
                <Row>
                    <Col span={10}>响应字段</Col>
                    <Col span={14}>字段类型</Col>
                </Row>
                <Row style={{ marginTop: 5, }}>
                    <Col span={10} style={{ paddingRight: 8, }}>
                        <Input
                            placeholder='请输入字段名称'
                            size='small'
                            value={response?.field}
                            onChange={(e) => {
                                setResponse({
                                    ...response,
                                    field: e.target.value
                                });
                                props.node.setData({
                                    ...props.node.data,
                                    input: {
                                        response: {
                                            ...response,
                                            field: e.target.value
                                        },
                                    },
                                });
                            }}
                        />
                    </Col>
                    <Col span={14}>
                        <Select
                            placeholder='请选择字段类型'
                            style={{ width: '100%' }}
                            size='small'
                            options={CNF.variableTypes.map(item => {
                                return {
                                    label: item,
                                    value: item,
                                }
                            })}
                            value={response?.type}
                            onChange={(value) => {
                                setResponse({
                                    ...response,
                                    type: value,
                                });
                                props.node.setData({
                                    ...props.node.data,
                                    input: {
                                        response: {
                                            ...response,
                                            type: value,
                                        },
                                    },
                                });
                            }}
                        />
                    </Col>
                </Row>
                <Divider style={{ marginLeft: '-25px', marginRight: '-25px', width: 'calc(100% + 50px)', }} />
                <p>输出</p>
                <div>
                    {
                        props.node?.data?.output && Object.keys(props.node?.data.output).map(key => {
                            return <Space key={key}><span>{key}</span><span style={{ color: CNF.basePlaceholderColor }}>{response && response.type ? response.type : 'string'}</span></Space>
                        })
                    }
                </div>
            </Modal>
        </ConfigProvider >
    );
}

export default APINodeEntity;